import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';


const MoreVertIcon = ({ size }) => (
  <div style={{ display: 'inline-block' }}>
    <div style={{
      backgroundColor: '#A4ADC1',
      height: size,
      width: size,
      borderRadius: '50%',
      marginBottom: size / 2,
    }}
    />
    <div style={{
      backgroundColor: '#A4ADC1',
      height: size,
      width: size,
      borderRadius: '50%',
      marginBottom: size / 2,
    }}
    />
    <div style={{
      backgroundColor: '#A4ADC1', height: size, width: size, borderRadius: '50%',
    }}
    />
  </div>
);

MoreVertIcon.propTypes = {
  size: PropTypes.number.isRequired,
};

export default Radium(MoreVertIcon);



// WEBPACK FOOTER //
// ./src/assets/MoreVertIcon.jsx